import { Component, computed, signal, Signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PatientService } from '../../services/patient.service';
import { AppointmentService } from '../../services/appointment.service';
import { BillingService } from '../../services/billing.service';
import { MedicalRecordService } from '../../services/medical-record.service';
import { Patient } from '../../models/patient.model';
import { Appointment } from '../../models/appointment.model';
import { Bill } from '../../models/billing.model';
import { MedicalRecord } from '../../models/medical-record.model';
import { ButtonComponent } from '../ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard',
  imports: [CommonModule, RouterLink, DatePipe, ButtonComponent, TranslateModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {
  patients!: Signal<Patient[]>;
  appointments!: Signal<Appointment[]>;
  bills!: Signal<Bill[]>;
  records!: Signal<MedicalRecord[]>;

  constructor(
    private patientService: PatientService,
    private appointmentService: AppointmentService,
    private billingService: BillingService,
    private medicalRecordService: MedicalRecordService
  ) {
    this.patients = this.patientService.getPatients();
    this.appointments = this.appointmentService.getAppointments();
    this.bills = this.billingService.getBills();
    this.records = this.medicalRecordService.getRecords();
  }

  stats = computed(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const todayAppointments = this.appointments().filter((a: Appointment) => {
      const apptDate = new Date(a.date);
      apptDate.setHours(0, 0, 0, 0);
      return apptDate.getTime() === today.getTime();
    });

    const pendingBills = this.bills().filter((b: Bill) => b.status === 'Pending');
    const totalRevenue = this.bills()
      .filter((b: Bill) => b.status === 'Paid')
      .reduce((sum: number, b: Bill) => sum + b.total, 0);

    return {
      totalPatients: this.patients().length,
      todayAppointments: todayAppointments.length,
      pendingBills: pendingBills.length,
      totalRevenue: totalRevenue
    };
  });

  upcomingAppointments = computed(() => {
    const today = new Date();
    return this.appointments()
      .filter((a: Appointment) => new Date(a.date) >= today && a.status !== 'Cancelled')
      .sort((a: Appointment, b: Appointment) => new Date(a.date).getTime() - new Date(b.date).getTime())
      .slice(0, 5);
  });

  recentPatients = computed(() => {
    return this.patients()
      .sort((a: Patient, b: Patient) => b.createdAt.getTime() - a.createdAt.getTime())
      .slice(0, 5);
  });
}

